import { useState } from "react";
import { Search } from "lucide-react";

const SearchForm = ({ onSearch, placeholder }: any) => {
    const [searchTerm, setSearchTerm] = useState("");
    const handleSearchChange = (e: any) => {
        setSearchTerm(e.target.value);
    };

    const handleSubmit = (e: any) => {
        e.preventDefault();
        if (typeof onSearch === "function") {
            onSearch(searchTerm);
        }
    };

    const handleKeyPress = (e: any) => {
        if (e.key === "Enter") {
            e.preventDefault();
            if (typeof onSearch === "function") {
                onSearch(searchTerm);
            }
        }
    };

    return (
        <form onSubmit={handleSubmit} className="cht-relative cht-w-full !cht-font-body">
            <div className="cht-relative cht-flex cht-items-center">
                <Search className="cht-absolute cht-left-4 cht-w-4 cht-h-4 cht-text-slate-400 cht-pointer-events-none" />
                <input
                    type="text"
                    className="cht-w-full cht-pl-11 cht-pr-4 cht-py-3 cht-rounded-[16px] cht-border cht-border-slate-200/80 cht-bg-white cht-text-[#1e293b] cht-text-sm placeholder:cht-text-slate-400 focus:cht-outline-none focus:cht-ring-2 focus:cht-ring-[#3e57da]/30 focus:cht-border-[#3e57da] cht-shadow-soft cht-transition-all"
                    id="search"
                    placeholder={placeholder || "Search articles..."}
                    name="search"
                    onChange={handleSearchChange}
                    value={searchTerm}
                    onKeyDown={handleKeyPress}
                />
            </div>
        </form>
    );
};

export default SearchForm;
